import { TRule } from '../../typings';

export const UNIKOMERC_PRICELIST_RULESET: TRule[] = [
  {
    type: 'rule.map',
    sourceKey: "c.['EAN']",
    destination: 'product',
    targetKey: 'ean',
  },
  {
    type: 'rule.map',
    sourceKey: "c.['SIFRA_ARTIKLA']",
    destination: 'product',
    targetKey: 'supplierCode',
  },
  {
    type: 'rule.map',
    sourceKey: 'c.Brand',
    destination: 'product',
    targetKey: 'brand',
  },
  {
    type: 'rule.map',
    sourceKey: "c.['CIJENA_BEZ_PDV_SA_24_RABATOM']",
    destination: 'product',
    targetKey: 'priceEUR',
    outputType: 'number',
  },
];
